import { createEntityAdapter, EntityState } from '@ngrx/entity';
import * as actions from './resource.actions';
import { createFeatureSelector } from '@ngrx/store';

export interface Resource {
    id: string;
    label: string;
    options: any;
}

// Entity Adapter
export const resourceAdapter = createEntityAdapter<Resource>();

export interface State extends EntityState<Resource> {

}

const defaultResourcesState = {}

export const initialState: State = resourceAdapter.getInitialState(defaultResourcesState);

export function resourceReducer(
    state: State = initialState,
    action: actions.ResourceActions
) {
    switch (action.type) {
        case actions.LOAD_SUCCESS:
            return resourceAdapter.addAll(action.resources, state);

        case actions.CREATE:
            return resourceAdapter.addOne(action.resource, state);

        case actions.UPDATE:
            return resourceAdapter.updateOne({
                id: action.id,
                changes: action.changes
            }, state);

        case actions.DELETE:
            return resourceAdapter.removeOne(action.id, state);

        default:
            return state;
    }
}

export const getResourceState = createFeatureSelector<State>('resources');

export const {selectIds, selectEntities, selectAll, selectTotal} = resourceAdapter.getSelectors(getResourceState);


// WEBPACK FOOTER //
// ./libs/chassis-resource/src/+state/resource.reducer.ts